import { INotificationFilter } from "@/features/notification/notification.types";
import { Ref, ref } from "vue";
import { defineStore } from "pinia";
import { notificationService } from "@/features/notification/notification.service";
import { useNotification } from "@/utils/notification";

const { pushNotification } = useNotification();

export const useNotificationStore = defineStore("notification", () => {
  const notificationFilter = ref<INotificationFilter>({
    per_page: 50,
    page: 1,
    type: "",
    unread_only: null,
  });

  const notificationCount = ref(0);

  async function getList(loading: Ref<boolean>, cl: any) {
    loading.value = true;

    await notificationService
      .getList({ ...notificationFilter.value })
      .then((res) => {
        cl(res.data);
      })
      .catch((err) => {
        pushNotification(err.response?.data?.detail || err, "error");
      })
      .finally(() => {
        loading.value = false;
      });
  }

  async function getCount(loading: Ref<boolean>, cl: any) {
    loading.value = true;

    await notificationService
      .notificationCount()
      .then((res) => {
        cl(res.data);
      })
      .catch((err) => {
        pushNotification(err.response?.data?.detail || err, "error");
      })
      .finally(() => {
        loading.value = false;
      });
  }

  async function notificationRead(loading: Ref<boolean>, id: string, cl: any) {
    loading.value = true;

    await notificationService
      .readNotification(id)
      .then((res) => {
        cl(res.data);
      })
      .catch((err) => {
        pushNotification(err.response?.data?.detail || err, "error");
      })
      .finally(() => {
        loading.value = false;
      });
  }

  async function readAll(loading: Ref<boolean>, cl: any) {
    loading.value = true;

    await notificationService
      .readAll()
      .then((res) => {
        cl(res.data);
      })
      .catch((err) => {
        pushNotification(err.response?.data?.detail || err, "error");
      })
      .finally(() => {
        loading.value = false;
      });
  }

  return {
    notificationFilter,
    notificationCount,
    getList,
    getCount,
    notificationRead,
    readAll,
  };
});
